import React, { useEffect, Fragment, useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { DfpComponent } from "../../../ads/dfp-component";
import SearchEntity from "../search-entity/search";
import { ProfileImage } from "../profile-image";
import TrendingStories from "../trending-stories";

import "../entity-list.m.css";

export function EntityPagePeople({ data = {}, config = {} }) {
  const sketchesHost = config["sketches-host"];

  let placeData = get(data, ["data", "entities"], []);
  placeData = placeData.sort((a, b) => Number(a.sequence || 200) - Number(b.sequence || 200));
  const [showLoadmore, setShowLoadmore] = useState(false);
  const limit = 16;
  const [offset, setOffset] = useState(limit);
  const [items, setItems] = useState(placeData?.length > limit ? placeData.slice(0, limit) : placeData);
  const entityName = "person";

  const getLoadMorePlaces = async () => {
    const newItems = placeData.slice(offset, limit + offset);
    setItems([...items, ...newItems]);
    setOffset((prevOffset) => prevOffset + limit);
  };

  const midAd1 = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "mid_page_1"], {}));
  const midAd2 = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "mid_page_2"], {}));
  const footerAd = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "footer_1"], {}));

  const handleLoadMore = async () => {
    await getLoadMorePlaces();
  };

  useEffect(() => {
    items?.length >= offset ? setShowLoadmore(true) : setShowLoadmore(false);
  }, [offset]);

  return (
    <div styleName="entity-list-container">
      <div styleName="top-banner">
        <img src="https://images.assettype.com/gulfnews/2025-09-25/42l03s3r/people-desktop.png" />
      </div>
      <div styleName="top-banner-mobile">
        <img src="https://images.assettype.com/gulfnews/2025-09-25/6ul0gfb2/people-mobile.png" />
      </div>
      <SearchEntity entityName={entityName} onResults={setItems} />
      {items?.length ? (
        <div styleName="entity-list">
          {items.map((item, index) => {
            const profileImg = get(item, ["profile-image"], []);
            return (
              <Fragment key={index}>
                <div styleName="entity-list-detail">
                  <Link href={`${sketchesHost}/people/${item?.slug}`}>
                    <ProfileImage imageUrl={profileImg} />
                  </Link>
                  <div styleName="info">
                    <Link href={`${sketchesHost}/people/${item?.slug}`}>
                      <div styleName="name">{item?.name}</div>
                    </Link>
                    <div styleName="bio">{item?.["designation-occupation"]}</div>
                  </div>
                  <div styleName="details">
                    <Link href={`${sketchesHost}/people/${item?.slug}`}>View Profile</Link>
                  </div>
                </div>
                {index === 23 && (
                  <aside styleName="ad-slot-970x250-wrapper">
                    <DfpComponent adStyleName={"ad-slot-size-970x250"} id={midAd2?.id} />
                  </aside>
                )}
              </Fragment>
            );
          })}
        </div>
      ) : (
        <div styleName="entity-list no-result">No result found.</div>
      )}
      {showLoadmore && <div styleName="load-more">{<button onClick={handleLoadMore}>LOAD MORE</button>}</div>}
      <div styleName="bottom-ad-container">
        <DfpComponent adStyleName={"ad-slot-size-970x250"} id={midAd1?.id} />
      </div>
      <TrendingStories />
      <div styleName="bottom-ad-container">
        <DfpComponent adStyleName="ad-slot-size-970x250" id={footerAd?.id} />
      </div>
    </div>
  );
}
